// extracted by mini-css-extract-plugin
module.exports = {"address":"Address_address__EUgPP","name":"Address_name__shTpE","description":"Address_description__dr_YN"};